module.exports = fox._r("images/promo/tutorial/08.png", __webpack_public_path__ + "_/common/images/promo/tutorial/08.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/08.png
// module id = 656
// module chunks = 2